import { useDispatch, useSelector } from "react-redux";
import getJsonFromApi from "../Common/getJsonFromApi";
import { setData } from "../redux/reportSlice";

function FilterButton(props) {
  const dispatch = useDispatch();
  const filterSettings = useSelector((state) => state.report.filterSettings);
  const sortSettings = useSelector((state) => state.report.sortSettings);
  const sortOrderParameter = sortSettings.map((so) => `sortOrder=${so}`);

  const onClick = () => {
    const queryString = Object.keys(filterSettings)
      .map((k) => {
        const values = [];
        filterSettings[k].forEach((v) => values.push(`${k}=${v}`));
        return values.join("&");
      })
      .concat(sortOrderParameter)
      .join("&");

    let url = props.filterUrl;
    if (queryString) {
      url += `?${queryString}`;
    }
    getJsonFromApi(url).then((data) => {
      dispatch(setData(data));
    });
  };
  return (
    <button
      className={"btn yellow btn-lg filter-button"}
      onClick={onClick}
      data-testid="filter-button"
    >
      {props.label}
    </button>
  );
}

export default FilterButton;
